/* tslint:disable */
/* eslint-disable */
/**
 * Mercatus Admin Console
 * Mercatus Admin Console
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AddRoleMembersRequest } from '../model';
// @ts-ignore
import { CreateRoleRequest } from '../model';
// @ts-ignore
import { RoleDetailResponse } from '../model';
// @ts-ignore
import { RoleListItemResponse } from '../model';
// @ts-ignore
import { RoleUserResponse } from '../model';
// @ts-ignore
import { UpdateRoleRequest } from '../model';
/**
 * RolesApi - axios parameter creator
 * @export
 */
export const RolesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * A caller without an admin license cannot add a user who holds one: the license rule that hides such users from the member list makes their ids read as unrecognised here too.
         * @summary Add users to a role.
         * @param {number} roleId Role ID
         * @param {AddRoleMembersRequest} addRoleMembersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRoleMembers: async (roleId: number, addRoleMembersRequest: AddRoleMembersRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('addRoleMembers', 'roleId', roleId)
            // verify required parameter 'addRoleMembersRequest' is not null or undefined
            assertParamExists('addRoleMembers', 'addRoleMembersRequest', addRoleMembersRequest)
            const localVarPath = `/roles/{roleId}/members`
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addRoleMembersRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The role belongs to the authenticated user\'s organization and starts with no entitlements and no members.
         * @summary Create a role.
         * @param {CreateRoleRequest} createRoleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRole: async (createRoleRequest: CreateRoleRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'createRoleRequest' is not null or undefined
            assertParamExists('createRole', 'createRoleRequest', createRoleRequest)
            const localVarPath = `/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRoleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Also ends every membership of the role. Refused when a member would be left without any role at all, so that no user is stranded without one.
         * @summary Delete a role.
         * @param {number} roleId Role ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRole: async (roleId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('deleteRole', 'roleId', roleId)
            const localVarPath = `/roles/{roleId}`
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a role by ID.
         * @param {number} roleId Role ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRole: async (roleId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('getRole', 'roleId', roleId)
            const localVarPath = `/roles/{roleId}`
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The active users of the organization that do not already belong to the role. A caller without an admin license does not see users who hold one.
         * @summary List the users who can be added to a role.
         * @param {number} roleId Role ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAssignableUsers: async (roleId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('listAssignableUsers', 'roleId', roleId)
            const localVarPath = `/roles/{roleId}/assignable-users`
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists users with an active membership in the requested role. Lite follows the same persisted membership rules as the other roles. Members may be enabled or disabled. A caller without an admin license does not see users who hold one.
         * @summary List the users who belong to a role.
         * @param {number} roleId Role ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRoleMembers: async (roleId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('listRoleMembers', 'roleId', roleId)
            const localVarPath = `/roles/{roleId}/members`
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Grid rows, ordered by name. Only the organization\'s own active roles are returned. The built-in Default and Lite roles are listed only to members of the admin organization, who alone administer them; to anyone else they are absent here and on every other endpoint.
         * @summary List the roles of the authenticated user\'s organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRoles: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Refused when the role is the user\'s only one, so that no user is stranded without a role. A member whose license the caller does not see reads as no member at all, the same way the member list omits them.
         * @summary Remove a user from a role.
         * @param {number} roleId Role ID
         * @param {number} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeRoleMember: async (roleId: number, userId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('removeRoleMember', 'roleId', roleId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('removeRoleMember', 'userId', userId)
            const localVarPath = `/roles/{roleId}/members/{userId}`
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * A full replacement of the editable fields: an omitted description clears rather than preserves. Members and entitlements are unaffected.
         * @summary Update a role.
         * @param {number} roleId Role ID
         * @param {UpdateRoleRequest} updateRoleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRole: async (roleId: number, updateRoleRequest: UpdateRoleRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('updateRole', 'roleId', roleId)
            // verify required parameter 'updateRoleRequest' is not null or undefined
            assertParamExists('updateRole', 'updateRoleRequest', updateRoleRequest)
            const localVarPath = `/roles/{roleId}`
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRoleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RolesApi - functional programming interface
 * @export
 */
export const RolesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RolesApiAxiosParamCreator(configuration)
    return {
        /**
         * A caller without an admin license cannot add a user who holds one: the license rule that hides such users from the member list makes their ids read as unrecognised here too.
         * @summary Add users to a role.
         * @param {number} roleId Role ID
         * @param {AddRoleMembersRequest} addRoleMembersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addRoleMembers(roleId: number, addRoleMembersRequest: AddRoleMembersRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addRoleMembers(roleId, addRoleMembersRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * The role belongs to the authenticated user\'s organization and starts with no entitlements and no members.
         * @summary Create a role.
         * @param {CreateRoleRequest} createRoleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRole(createRoleRequest: CreateRoleRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRole(createRoleRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Also ends every membership of the role. Refused when a member would be left without any role at all, so that no user is stranded without one.
         * @summary Delete a role.
         * @param {number} roleId Role ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRole(roleId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRole(roleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a role by ID.
         * @param {number} roleId Role ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRole(roleId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRole(roleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * The active users of the organization that do not already belong to the role. A caller without an admin license does not see users who hold one.
         * @summary List the users who can be added to a role.
         * @param {number} roleId Role ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAssignableUsers(roleId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RoleUserResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAssignableUsers(roleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Lists users with an active membership in the requested role. Lite follows the same persisted membership rules as the other roles. Members may be enabled or disabled. A caller without an admin license does not see users who hold one.
         * @summary List the users who belong to a role.
         * @param {number} roleId Role ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listRoleMembers(roleId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RoleUserResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listRoleMembers(roleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Grid rows, ordered by name. Only the organization\'s own active roles are returned. The built-in Default and Lite roles are listed only to members of the admin organization, who alone administer them; to anyone else they are absent here and on every other endpoint.
         * @summary List the roles of the authenticated user\'s organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listRoles(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RoleListItemResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listRoles(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Refused when the role is the user\'s only one, so that no user is stranded without a role. A member whose license the caller does not see reads as no member at all, the same way the member list omits them.
         * @summary Remove a user from a role.
         * @param {number} roleId Role ID
         * @param {number} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeRoleMember(roleId: number, userId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeRoleMember(roleId, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * A full replacement of the editable fields: an omitted description clears rather than preserves. Members and entitlements are unaffected.
         * @summary Update a role.
         * @param {number} roleId Role ID
         * @param {UpdateRoleRequest} updateRoleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRole(roleId: number, updateRoleRequest: UpdateRoleRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRole(roleId, updateRoleRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RolesApi - factory interface
 * @export
 */
export const RolesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RolesApiFp(configuration)
    return {
        /**
         * A caller without an admin license cannot add a user who holds one: the license rule that hides such users from the member list makes their ids read as unrecognised here too.
         * @summary Add users to a role.
         * @param {number} roleId Role ID
         * @param {AddRoleMembersRequest} addRoleMembersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRoleMembers(roleId: number, addRoleMembersRequest: AddRoleMembersRequest, options?: any): AxiosPromise<void> {
            return localVarFp.addRoleMembers(roleId, addRoleMembersRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * The role belongs to the authenticated user\'s organization and starts with no entitlements and no members.
         * @summary Create a role.
         * @param {CreateRoleRequest} createRoleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRole(createRoleRequest: CreateRoleRequest, options?: any): AxiosPromise<RoleDetailResponse> {
            return localVarFp.createRole(createRoleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Also ends every membership of the role. Refused when a member would be left without any role at all, so that no user is stranded without one.
         * @summary Delete a role.
         * @param {number} roleId Role ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRole(roleId: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteRole(roleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a role by ID.
         * @param {number} roleId Role ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRole(roleId: number, options?: any): AxiosPromise<RoleDetailResponse> {
            return localVarFp.getRole(roleId, options).then((request) => request(axios, basePath));
        },
        /**
         * The active users of the organization that do not already belong to the role. A caller without an admin license does not see users who hold one.
         * @summary List the users who can be added to a role.
         * @param {number} roleId Role ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAssignableUsers(roleId: number, options?: any): AxiosPromise<Array<RoleUserResponse>> {
            return localVarFp.listAssignableUsers(roleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists users with an active membership in the requested role. Lite follows the same persisted membership rules as the other roles. Members may be enabled or disabled. A caller without an admin license does not see users who hold one.
         * @summary List the users who belong to a role.
         * @param {number} roleId Role ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRoleMembers(roleId: number, options?: any): AxiosPromise<Array<RoleUserResponse>> {
            return localVarFp.listRoleMembers(roleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Grid rows, ordered by name. Only the organization\'s own active roles are returned. The built-in Default and Lite roles are listed only to members of the admin organization, who alone administer them; to anyone else they are absent here and on every other endpoint.
         * @summary List the roles of the authenticated user\'s organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRoles(options?: any): AxiosPromise<Array<RoleListItemResponse>> {
            return localVarFp.listRoles(options).then((request) => request(axios, basePath));
        },
        /**
         * Refused when the role is the user\'s only one, so that no user is stranded without a role. A member whose license the caller does not see reads as no member at all, the same way the member list omits them.
         * @summary Remove a user from a role.
         * @param {number} roleId Role ID
         * @param {number} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeRoleMember(roleId: number, userId: number, options?: any): AxiosPromise<void> {
            return localVarFp.removeRoleMember(roleId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * A full replacement of the editable fields: an omitted description clears rather than preserves. Members and entitlements are unaffected.
         * @summary Update a role.
         * @param {number} roleId Role ID
         * @param {UpdateRoleRequest} updateRoleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRole(roleId: number, updateRoleRequest: UpdateRoleRequest, options?: any): AxiosPromise<RoleDetailResponse> {
            return localVarFp.updateRole(roleId, updateRoleRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RolesApi - object-oriented interface
 * @export
 * @class RolesApi
 * @extends {BaseAPI}
 */
export class RolesApi extends BaseAPI {
    /**
     * A caller without an admin license cannot add a user who holds one: the license rule that hides such users from the member list makes their ids read as unrecognised here too.
     * @summary Add users to a role.
     * @param {number} roleId Role ID
     * @param {AddRoleMembersRequest} addRoleMembersRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    public addRoleMembers(roleId: number, addRoleMembersRequest: AddRoleMembersRequest, options?: any) {
        return RolesApiFp(this.configuration).addRoleMembers(roleId, addRoleMembersRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The role belongs to the authenticated user\'s organization and starts with no entitlements and no members.
     * @summary Create a role.
     * @param {CreateRoleRequest} createRoleRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    public createRole(createRoleRequest: CreateRoleRequest, options?: any) {
        return RolesApiFp(this.configuration).createRole(createRoleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Also ends every membership of the role. Refused when a member would be left without any role at all, so that no user is stranded without one.
     * @summary Delete a role.
     * @param {number} roleId Role ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    public deleteRole(roleId: number, options?: any) {
        return RolesApiFp(this.configuration).deleteRole(roleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a role by ID.
     * @param {number} roleId Role ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    public getRole(roleId: number, options?: any) {
        return RolesApiFp(this.configuration).getRole(roleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The active users of the organization that do not already belong to the role. A caller without an admin license does not see users who hold one.
     * @summary List the users who can be added to a role.
     * @param {number} roleId Role ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    public listAssignableUsers(roleId: number, options?: any) {
        return RolesApiFp(this.configuration).listAssignableUsers(roleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists users with an active membership in the requested role. Lite follows the same persisted membership rules as the other roles. Members may be enabled or disabled. A caller without an admin license does not see users who hold one.
     * @summary List the users who belong to a role.
     * @param {number} roleId Role ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    public listRoleMembers(roleId: number, options?: any) {
        return RolesApiFp(this.configuration).listRoleMembers(roleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Grid rows, ordered by name. Only the organization\'s own active roles are returned. The built-in Default and Lite roles are listed only to members of the admin organization, who alone administer them; to anyone else they are absent here and on every other endpoint.
     * @summary List the roles of the authenticated user\'s organization.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    public listRoles(options?: any) {
        return RolesApiFp(this.configuration).listRoles(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Refused when the role is the user\'s only one, so that no user is stranded without a role. A member whose license the caller does not see reads as no member at all, the same way the member list omits them.
     * @summary Remove a user from a role.
     * @param {number} roleId Role ID
     * @param {number} userId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    public removeRoleMember(roleId: number, userId: number, options?: any) {
        return RolesApiFp(this.configuration).removeRoleMember(roleId, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * A full replacement of the editable fields: an omitted description clears rather than preserves. Members and entitlements are unaffected.
     * @summary Update a role.
     * @param {number} roleId Role ID
     * @param {UpdateRoleRequest} updateRoleRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    public updateRole(roleId: number, updateRoleRequest: UpdateRoleRequest, options?: any) {
        return RolesApiFp(this.configuration).updateRole(roleId, updateRoleRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
